import galeriaBonita from '../lib/galeria';

const cabecera = () => {
    [].forEach.call(document.querySelectorAll('.bloque--cabecera'), (contenedor: HTMLElement) => {
        const titulo = contenedor.querySelector('.cabecera__titulo') as HTMLElement,
            textoTitulo = titulo.querySelector('div') as HTMLElement,
            anteTitulo = contenedor.querySelector('.cabecera__antetitulo') as HTMLElement,
            texto = contenedor.querySelector('.cabecera__texto') as HTMLElement,
            galeria = contenedor.querySelector('.cabecera__galeria') as HTMLElement,
            datos = JSON.parse(galeria.dataset.imagenes!);

        galeriaBonita(galeria, {
            elementosDeMas: 1,
            duracion: 1000,
            onCambioStart: (indice: number) => {
                titulo.style.opacity = '0';
            },
            onCambioEnd: (indice: number) => {
                titulo.style.opacity = '1';
            },
            onCambio: (indice: number, progreso: number) => {
                const opacidad = progreso < .5 ? 1 - progreso * 2 : (progreso - .5) * 2;

                titulo.style.opacity = opacidad.toString();
                texto.style.opacity = opacidad.toString();

                console.log(opacidad);

                if (progreso > .5) {
                    textoTitulo.textContent = datos[indice].titulo;
                    texto.innerHTML = datos[indice].texto;
                    anteTitulo.textContent = datos[indice].antetitulo;
                }
            },
        });
    });
}

export default cabecera;